import { createClient } from 'contentful';

const client = createClient({
  space: '1rl1jlxxxe6l',
  accessToken: '45CfDXmLKyusG7xKSwYwBDNTqyV0EcQdgWKMi6MxNPQ',
  environment: 'master',
});

export default client;